import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";
import { Progress } from "@/components/ui/progress";
import { StatusBadge } from "@/components/portal/StatusBadge";

export const TYPE_LABEL = { custom_home: "Custom home", concrete: "Concrete work", other: "Other" };

export const ProjectCard = ({ p }) => (
  <Link to={`/portal/projects/${p.id}`} data-testid={`project-card-${p.id}`} className="block rounded-xl border border-[#E6E2DA] bg-white p-5 transition-colors duration-200 hover:border-[#F2B91C]/50">
    <div className="flex items-start justify-between gap-3">
      <div className="min-w-0">
        <p className="eyebrow mb-1">{TYPE_LABEL[p.project_type] || p.project_type}</p>
        <h3 className="font-display truncate text-lg font-bold">{p.name}</h3>
      </div>
      <StatusBadge status={p.status} testId="project-status-badge" />
    </div>
    {p.address && <p className="mt-2 flex items-center gap-1 text-xs text-[#5C5850]"><MapPin size={12} />{p.address}</p>}
    <div className="mt-4 flex items-center gap-3">
      <Progress value={p.progress} className="h-2 bg-[#F2EFE9] [&>div]:bg-[#F2B91C]" />
      <span className="font-mono-num text-sm font-semibold">{p.progress}%</span>
    </div>
    {p.customer_name && <p className="mt-3 text-xs text-[#8C877D]">Client: {p.customer_name}</p>}
  </Link>
);
